import React from 'react';
import './css/ChatLoader.css';

const ChatLoader = () => {
    return (
        <div className="chat-loader">
            <div className="chat-bubble">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
            </div>
        </div>
    );
};

export default ChatLoader;
